import { getOwnerId } from 'legacy/lut/selectors/app'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { REQUEST_LANDING_PARTNER_SEARCH } from 'partner360/features/landing/constants'
import { landingSearchPartner } from 'partner360/services/landing/landingSearchPartner'

interface IRequestLandingSearchPartner {
  searchStr: string
  fYear: number
}
export const requestLandingSearchPartner = createAsyncThunk(
  REQUEST_LANDING_PARTNER_SEARCH,
  async ({ searchStr, fYear }: IRequestLandingSearchPartner, { getState }) => {
    const ownerId = compose(getOwnerId, getState)()

    return await landingSearchPartner({
      ownerId,
      searchStr,
      fYear,
    })
  }
)
